export default __webpack_public_path__ + "static/media/calendar.0ff63aa5.svg";